export { HighlightSummary, HighlightIssueLink } from './view';
